import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { CREATE_QUICK_QUOTE } from 'src/store/actions/quoteActions';
import StepFour from './StepFour';
import FinalStep from './FinalStep';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepOne from './StepOne';

const CurrentStep = ({
  activeStep,
  data,
  setData,
  onNext,
  onBack,
  onSubmit,
  onCloseForm,
  resetRef
}) => {
  const loading = useSelector(isLoadingSelector([CREATE_QUICK_QUOTE.action]));

  if (activeStep === 0) {
    return <StepOne data={data} onNext={onNext} onBack={onCloseForm} />;
  }

  if (activeStep === 1) {
    return (
      <StepTwo
        data={data}
        setData={setData}
        handleNext={onNext}
        handleBack={onBack}
        onCloseForm={onCloseForm}
        resetRef={resetRef}
        activeStep={activeStep}
      />
    );
  }

  if (activeStep === 2) {
    return (
      <StepThree
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  if (activeStep === 3) {
    return (
      <StepFour
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }
  return (
    <FinalStep
      data={data}
      loading={loading}
      handleBack={onBack}
      handleSubmit={onSubmit}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  setData: PropTypes.func,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCloseForm: PropTypes.func.isRequired,
  resetRef: PropTypes.any.isRequired
};

export default CurrentStep;
